<div class="hyperkit-editor-wrapper">
    <ngx-editor-menu [editor]="editor"></ngx-editor-menu>
    <ngx-editor 
        [editor]="editor" 
        [(ngModel)]="html" 
        (ngModelChange)="onEditorChange($event)"
        [placeholder]="'Enter text here...'"
    ></ngx-editor>
</div>